import styles from './Toolbar.module.css';

/** Barra de filtros/ações acima de uma tabela/lista. */
export default function Toolbar({ children }) {
  return <div className={styles.toolbar}>{children}</div>;
}
